import {useConfigStore} from "@/stores/config.ts";

export default class Google {
    initialized: boolean = false;
    public initialize() {
        if (this.initialized) {
            return;
        }

        const configStore = useConfigStore();
        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${configStore.googleApiKey}&loading=async&libraries=places&callback=initMap`;
        script.async = true;
        script.defer = true;
        script.onerror = () => {
            console.error('Failed to load google service.')
        };
        document.head.appendChild(script);
    }

    public getMapService() {
        return  window.google.maps;
    }
}